import React from "react";
import { object, string } from "prop-types";

import BigSectionName from "../../atoms/BigSectionName";
import SubSectionsMenuItems from "../../atoms/SubSectionsMenuItems";
import Anchor from "../../atoms/Anchor";

import "./sectionMenuDom.m.css";

const SectionMenuDom = ({
  domainSectionObj,
  domainSlug,
  sectionsDataForHeader,
  sectionMenuItem,
  multiDomainWrapperName,
}) => {
  return (
    <nav styleName={`navbar ${multiDomainWrapperName ? `nav-${multiDomainWrapperName}` : ""}`} className="navbar">
      <ul styleName="parent-section">
        <BigSectionName
          domainSectionObj={domainSectionObj}
          domainSlug={domainSlug}
          sectionsDataForHeader={sectionsDataForHeader}
        />
      </ul>
      {sectionMenuItem && sectionMenuItem.children.length > 0 ? (
        <ul styleName="sub-sections" className="sub-sections">
          {sectionMenuItem.children.slice(0, 12).map((item, index) => (
            <li
              styleName="child-section"
              className={` ${item.title} child-section ${
                sectionsDataForHeader.currentSectionUrl === item.completeUrl ? "current-section" : ""
              }`}
              key={index}
            >
              {item.completeUrl === "/#" ? (
                <span>{item.title}</span>
              ) : (
                <Anchor aria-label={item.title} href={item.completeUrl}>
                  {item.title}
                </Anchor>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <SubSectionsMenuItems sectionsDataForHeader={sectionsDataForHeader} />
      )}
    </nav>
  );
};

SectionMenuDom.propTypes = {
  domainSectionObj: object,
  domainSlug: string,
  sectionsDataForHeader: object,
  sectionMenuItem: object,
  multiDomainWrapperName: string,
};

export default SectionMenuDom;
